module.exports = __webpack_public_path__ + "static/media/envelop-base.ee138dad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/envelop-base.png
// module id = 7582
// module chunks = 0